import { useEffect, useState } from 'react';
import { Input, Modal, ModalBody } from 'reactstrap';
import { useRecoilValue } from 'recoil';
import { toast } from 'react-hot-toast';
import { find, map } from 'lodash';

import { useUsersActions } from '../../../../services/actions/users.actions';
import { crudUserAtom } from '../../../../services/atoms/users.atoms';
import { newValidatePhone, validatePhone } from '../../../../helpers/functions';
import { ButtonLoading } from '../../../../components/buttons/button-loading';

const initialUserData = {
  email: '',
  phone_number: '',
  name: '',
  'custom:surname': '',
}

const getAttributes = (Attributes, key) => {
  let data = find(Attributes, (e) => e.Name === key);
  return data?.Value || ''
}

const EditUserModal = (props) => {
  const { open, toggle, selectedUser } = props;
  const { userList, updateUserAttributes, resetUserCrud } = useUsersActions();
  const [user, setUser] = useState(initialUserData);
  const userResolver = useRecoilValue(crudUserAtom);

  useEffect(() => {
    !open && setUser(initialUserData);
  }, [open])

  useEffect(() => {
    setUser({
      email: getAttributes(selectedUser.Attributes, 'email'),
      phone_number: getAttributes(selectedUser.Attributes, 'phone_number'),
      name: getAttributes(selectedUser.Attributes, 'name'),
      'custom:surname': getAttributes(selectedUser.Attributes, 'custom:surname'),
    })
  }, [selectedUser])

  useEffect(() => {
    userResolver.error && toast.error(userResolver.message);
    return () => resetUserCrud();
    // eslint-disable-next-line
  }, [userResolver.error, userResolver.message]);

  const handleChange = (key, value) => setUser((prevValues) => ({ ...prevValues, [key]: value }));

  const handleSubmit = (e) => {
    e.preventDefault();
    let keys = ['name', 'custom:surname', 'phone_number', 'email'];
    let attributes = map(keys, (e) => ({ Name: e, Value: e === 'phone_number' ? `${user[e]}` : user[e] }));
    updateUserAttributes(user.email, attributes, () => {
      toast.success('Usuario actualizado exitosamente');
      toggle('edit');
      userList();
    });
  }

  return (
    <Modal isOpen={open} toggle={toggle}>
      <div className='gm-modal-header'>
        <div className='gm-modal-title-container'>
          <div className='gm-modal-title'>Editar Usuario</div>
        </div>
        <button type="button" className="btn-close" aria-label="Close" onClick={toggle} />
      </div>
      <ModalBody>
        <form onSubmit={handleSubmit}>
          <div className='gm-modal-form-container'>
            <div className='gm-modal-form-section'>
              <div className='gm-modal-form-group'>
                <div className='gm-modal-input-group'>
                  <label htmlFor='name'>Nombre</label>
                  <input type="text"
                    id='name'
                    name="name"
                    value={user?.name || ''}
                    onChange={(e) => handleChange('name', e.target.value)}
                  />
                </div>
                <div className='gm-modal-input-group'>
                  <label htmlFor='surname'>Apellido</label>
                  <input
                    type="text"
                    id='surname'
                    name="surname"
                    value={user['custom:surname'] || ''}
                    onChange={(e) => handleChange('custom:surname', e.target.value)}
                  />
                </div>
              </div>
              <div className='gm-modal-form-group gm-wide-group'>
                <div className='gm-modal-input-group'>
                  <label htmlFor='phoneNumber'>Teléfono</label>
                  {/* <div className='gm-number-form'>
                    <div>+56</div>
                    <Input
                      type="text"
                      id='phone_number'
                      name='phone_number'
                      value={user.phone_number}
                      onChange={(e) => handleChange('phone_number', e.target.value)}
                      maxLength={20}
                      invalid={!newValidatePhone(user.phone_number)}
                    />
                  </div> */}
                                      <Input
                      type="text"
                      id='phone_number'
                      name='phone_number'
                      value={user.phone_number}
                      onChange={(e) => handleChange('phone_number', e.target.value)}
                      maxLength={20}
                      invalid={!newValidatePhone(user.phone_number)}
                      placeholder='+569 1234 5678'
                    />
                </div>
              </div>
              <div className='gm-modal-form-group gm-wide-group'>
                <div className='gm-modal-input-group '>
                  <label htmlFor='email'>Correo</label>
                  <input
                    type="text"
                    id='email'
                    name="email"
                    value={user?.email || ''}
                    onChange={(e) => handleChange('email', e.target.value)}
                    disabled
                  />
                </div>               
              </div>
            </div>
          </div>
          <div className='gm-modal-buttons'>
            <button type='button' className='gm-secondary-button' onClick={toggle}>
              Cancelar
            </button>
            <ButtonLoading
              className="gm-primary-button"
              type="submit"
              buttonLabel='Editar'
              disabled={userResolver.loading}
              loading={userResolver.loading}
            />
          </div>
        </form>
      </ModalBody>
    </Modal>
  );
}

export default EditUserModal;